export const default_permission = [
  {
    name: "dashboard",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "users",
    view: true,
    create: false,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "company",
    view: "N/A",
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "sku_mapping",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "uom_mapping",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "retailer",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "retailer_grouping",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "synonym_mapping",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "document",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: true,
    view_own_data_only: true,
  },
  {
    name: "upload_document",
    view: true,
    create: true,
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "workflow",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "email_listener",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "validation",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "terminal_keys",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "user_activity_logs",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "roles",
    view: true,
    create: true,
    update: true,
    delete: true,
    view_own_data_only: "N/A",
  },
  {
    name: "reports",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "reports/cash_balance_report",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "email_read_logs",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
    view_own_data_only: "N/A",
  },
  {
    name: "email_archive",
    view: true,
    create: "N/A",
    update: "N/A",
    delete: "N/A",
  },
];

// Display names for permissions renamed in the UI. The name itself is not
// changed because saved roles and the sidebar menu keys match on it.
const permission_label: Record<string, string> = {
  email_archive: "email_inbox",
};

export const getPermissionLabel = (name: string) =>
  permission_label[name] ?? name;
